export default "__VITE_ASSET__W1Lv2W7P__"